export default "https://cdn-static.gokick.com/assets/0d39bc0fcec85c93d0d6a7d8f262b967dc26f977/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";